const AUTH_CONTEXT_KEYS = new Set([
  'auth_token',
  'auth_token_type',
  'auth_user',
  'user',
  'userType',
  'company',
  'restaurant',
  'branch',
  'staff',
  'fcm_token',
  'uiud',
]);

const PATCH_FLAG = '__maedahStorageNamespaceInstalled';

function scopedKey(prefix: string, key: string): string {
  if (!AUTH_CONTEXT_KEYS.has(key) || key.startsWith(`${prefix}:`)) {
    return key;
  }

  return `${prefix}:${key}`;
}

export function installStorageNamespace(prefix: string): void {
  if (typeof window === 'undefined' || !window.localStorage || (window as any)[PATCH_FLAG]) {
    return;
  }

  const storage = window.localStorage;
  const storagePrototype = Object.getPrototypeOf(storage);
  const originalGetItem = storagePrototype.getItem;
  const originalSetItem = storagePrototype.setItem;
  const originalRemoveItem = storagePrototype.removeItem;
  const originalClear = storagePrototype.clear;
  const originalKey = storagePrototype.key;

  storagePrototype.getItem = function (this: Storage, key: string): string | null {
    return originalGetItem.call(this, this === storage ? scopedKey(prefix, String(key)) : key);
  };

  storagePrototype.setItem = function (this: Storage, key: string, value: string): void {
    return originalSetItem.call(this, this === storage ? scopedKey(prefix, String(key)) : key, value);
  };

  storagePrototype.removeItem = function (this: Storage, key: string): void {
    return originalRemoveItem.call(this, this === storage ? scopedKey(prefix, String(key)) : key);
  };

  storagePrototype.clear = function (this: Storage): void {
    if (this !== storage) {
      originalClear.call(this);
      return;
    }

    const keysToRemove: string[] = [];
    for (let index = 0; index < storage.length; index++) {
      const key = originalKey.call(storage, index);
      if (key?.startsWith(`${prefix}:`) || AUTH_CONTEXT_KEYS.has(key ?? '')) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => originalRemoveItem.call(storage, key));
  };

  (window as any)[PATCH_FLAG] = true;
}
